// extracted by mini-css-extract-plugin
export default {"editor":"RoleEditor_editor__43XUA","row":"RoleEditor_row__KacF7","scope":"RoleEditor_scope__L6DvN","only":"RoleEditor_only__OmXCG"};